/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DueNow/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import Stat from 'DesignSystem/Stat/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaCardHeader from 'DesignSystem/TysiaCard/TysiaCardHeader/index'
import TysiaCardHeaderTitle from 'DesignSystem/TysiaCard/TysiaCardHeader/TysiaCardHeaderTitle/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function DueNow({
  children,
  viewPath = "/DesignSystem/DueNow",
  marginTop = 0,
  dueNow,
  onClick
  
}) {
  let isMedia = useIsMedia()
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsRed700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.700'
        })
  return (<React.Fragment
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size={isMedia.mobile ? "small" : "large"}
 marginLeft="auto"
 marginRight="auto"
 flexGrow={0}
 marginTop={marginTop}
>
{childProps => (
<React.Fragment>
<TysiaCardHeader
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeader`}
>
{childProps => (
<TysiaCardHeaderTitle
{...childProps}
  viewPath={`${viewPath}/TysiaCardHeaderTitle`}
 text="Account Balance"
 level="h4"
/>
)}
</TysiaCardHeader>
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="DueNow.Vertical"
  data-view-path={viewPath}
 style={{'--mr-1-2qCu4e': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Due now"
/>
<Stat
  viewPath={`${viewPath}/Stat`}
 marginTop={dtSpaceXxs}
 color={dtColorsRed700}
 text={dueNow}
/>
</div>
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 alignSelf="flex-end"
 type="primary"
 onClick={onClick}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Pay Now"
/>
)}
</TysiaButton>
</React.Fragment>
)}
</TysiaCardContent>
</React.Fragment>
)}
</TysiaCard>
{children}
</React.Fragment>)
}